(() => {
  const shopifyApiRetryDelays = [0, 10, 25, 50, 100, 250, 500, 1000];
  const isGlobalPrivacyControlEnabled = navigator.globalPrivacyControl === true;

  const normalizePrivacyConsent = () => {
    const customerPrivacy = window.Shopify?.customerPrivacy;

    if (!customerPrivacy) return;

    const visitorConsent = customerPrivacy.currentVisitorConsent();

    if (!isGlobalPrivacyControlEnabled && visitorConsent.sale_of_data !== 'no') return;

    customerPrivacy.setTrackingConsent(
      {
        analytics: false,
        marketing: false,
        preferences: false,
        sale_of_data: false,
      },
      () => {}
    );
  };

  const normalizeSaleOfDataConsent = () => {
    const customerPrivacy = window.Shopify?.customerPrivacy;

    if (!customerPrivacy) return;

    const visitorConsent = customerPrivacy.currentVisitorConsent();

    const categoryConsents = [
      visitorConsent.marketing,
      visitorConsent.analytics,
      visitorConsent.preferences,
    ];
    const areAllCategoriesAccepted = categoryConsents.every((consent) => consent === 'yes');
    const areAllCategoriesDeclined = categoryConsents.every((consent) => consent === 'no');

    if (!areAllCategoriesAccepted && !areAllCategoriesDeclined) return;

    const expectedSaleOfDataConsent = areAllCategoriesAccepted ? 'yes' : 'no';

    if (visitorConsent.sale_of_data === expectedSaleOfDataConsent) return;

    customerPrivacy.setTrackingConsent(
      { sale_of_data: areAllCategoriesAccepted },
      () => {}
    );
  };

  const initializePrivacyConsent = () => {
    if (window.Shopify?.customerPrivacy) {
      normalizePrivacyConsent();
      return true;
    }

    if (!window.Shopify?.loadFeatures) return false;

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      (loadError) => {
        if (!loadError) normalizePrivacyConsent();
      }
    );

    return true;
  };

  const waitForShopifyPrivacyApi = (attempt = 0) => {
    if (initializePrivacyConsent()) return;

    const retryDelay = shopifyApiRetryDelays[attempt];

    if (retryDelay === undefined) return;

    window.setTimeout(() => waitForShopifyPrivacyApi(attempt + 1), retryDelay);
  };

  document.addEventListener('visitorConsentCollected', normalizeSaleOfDataConsent);

  waitForShopifyPrivacyApi();
})();
